import styled from 'styled-components'
import { layout, color, border } from 'styled-system'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { FlexDiv, A } from 'components/generic/HomePageComponents'

export const EasyEffectiveAfforadableImage = styled(LazyLoadImage)`
  margin-left: 10px
  margin-right: 10px
  margin-top: 50px
  max-width: 950px
`

export const CardColumn = styled(FlexDiv)`
  flex-direction: column
`

export const CardResponsiveContainer = styled(FlexDiv)`
  flex-direction: column
  @media (min-width: 650px) {
    flex-direction: row
  }
`

export const CardDiv = styled(FlexDiv)`
  flex-direction: column
  align-items: center
`

export const Button = styled(A)`
  backgroundColor: rgb(0,179,255);
  transition: background-color 0.5s ease;
  padding: 25px 10px;
  font-weight: bold;
  white-space: normal;
  font-size: 18px;
  margin-top: 35px;
  border: 2px #FFF solid;
  text-decoration: none;
  background-color: ${(props) => props.theme.colors.inverseColor};
  color: ${(props) => props.theme.buttonColor};
  border-radius: 5px;
  text-align: center;
  vertical-align: middle;
  
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.inverseColor};
    border-color: ${(props) => props.theme.colors.inverseColor};
  }
  ${layout}
  ${color}
  ${border}
`

export const InverseButton = styled(Button)`
  margin-left: 30px;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.inverseColor};
  border-color: ${(props) => props.theme.colors.inverseColor};
  font-size: 18px;
  width: 250px;

  vertical-align: middle;
  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    margin-left: 0px;
  }
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.inverseColor};
    color: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.white};
  }
`